import React from 'react';
import cs from 'classnames';

import sharedCSS from '~/components/shared.css';
import css from './index.css';

class TOS extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={cs(sharedCSS.widewrap, 'qa-content')}>
        <div className={cs(sharedCSS.wideStretchable, css.wrap)}>
          <h2>Terms of Service</h2>
          <div className={cs(css.content)}>
            <p className={cs(css.bold)}>Publish Date April 11 2019</p>
            <p className={cs(css.txtCenter, css.bold)}>Trucker Path, LLC</p>
            <p className={cs(css.txtCenter, css.bold)}>TERMS AND CONDITIONS</p>
            <h4>1. CONTRACTUAL RELATIONSHIP</h4>
            <p>
              These Terms and Conditions govern the access or use by you of websites, mobile applications,
              content, products and services (collectively, the “Services”) made available by Trucker
              Path LLC, a Delaware limited liability company, located at 2828 N. Central Ave., 7th Floor,
              Phoenix, AZ 85004, and its affiliated entities but excludes any websites, mobile applications,
              content, products and services that indicate they are subject to separate terms and conditions.
              An entity is an affiliate of Trucker Path LLC if the entity directly or indirectly controls,
              is controlled by or is under common control with the other entity. Trucker Path LLC and its
              affiliates are collectively referred to herein as “Trucker Path.” In instances when you have a
              separate signed agreement with us for certain Services, such signed agreement’s terms
              will be controlling with respect to the applicable Services in the event of an inconsistency with
              these Terms and Conditions. Further, additional terms may apply to certain Services
              and will be disclosed to you in connection with such Services. The additional terms
              will be controlling with respect to the applicable Services in the event of an
              inconsistency with these Terms and Conditions.
            </p>
            <p>
              By accessing and using the Services you are agreeing to these Terms and Conditions.
              If you are using the Services on behalf of a business entity, then your use means
              such business entity also accepts these Terms and Conditions. PLEASE READ THESE
              TERMS AND CONDITIONS CAREFULLY. BY ACCESSING AND USING THE SERVICES YOU ACKNOWLEDGE
              AND AGREE THAT YOU HAVE READ THESE TERMS AND CONDITIONS CAREFULLY, UNDERSTAND
              THEM  AND AGREE TO BE BOUND BY THEM. If you do not agree to these Terms and
              Conditions, do not access or otherwise use our Services.
            </p>
            <p>
              The term “you” or “your” as used in these Terms and Conditions refers to the
              individual using the Service and if you use the Service on behalf of a corporation,
              LLC, partnership, or other business entity, then “you” includes that business entity
              and any individuals associated therewith using our Service, who registers and
              maintains one or more user accounts with Trucker Path.
            </p>
            <p>
              The terms “us,” “our” and “we” as used in these Terms and Conditions refer to Trucker
              Path and each of its agents and representatives.
            </p>
            <h4>2. CHANGES TO TERMS AND CONDITIONS</h4>
            <p>
              We reserve the right to modify these Terms and Conditions relating to the Services
              at any time, effective upon posting of an updated version of the Terms and Conditions
              on the Service. Trucker Path will make reasonable efforts to notify you in advance of
              material changes to the Terms and Conditions, but you are responsible for regularly
              reviewing the Terms and Conditions. Continued use of the Services after any changes
              shall constitute your consent to such changes.
            </p>
            <h4>3. CHANGES TO SERVICES</h4>
            <p>
              We are constantly working to improve our Services. Thus, we may change, suspend or
              discontinue any aspect of our Services at any time. We may also impose limits or
              restrictions on certain Services, features or content or restrict your access to
              parts or all our Services at any time without notice or liability to you.
            </p>
            <h4>4. THE SERVICES AND ACCESS</h4>
            <p>
              The Services constitute a technology platform that enables you and other users of
              Trucker Path’s websites and mobile applications to utilize technology solutions
              that connect and facilitate business among people and entities involved in the
              transportation and logistics industry, including, but not limited to, freight-matching,
              load planning, automated transportation management, telematics and fleet management,
              route optimization, real-time rates, negotiation tools and other logistics solutions.
            </p>
            <p>
              Before being permitted to access or use certain Services, you will be asked to register
              and submit certain information about yourself (“Registration Information”). You represent
              and warrant that: (a) all Registration Information you have provided is true, accurate,
              current and complete; and (b) you will maintain and promptly update the Registration
              Information to keep it true, accurate, current and complete. In connection with your
              registration, you also will be asked to create a password-protected account to access
              the Services (an “Account”). You are responsible for all activity that occurs under your
              Account, and you agree to maintain the security and confidentiality of your Account
              information and password at all times. You agree to notify us immediately of any actual
              or suspected unauthorized use of your Account. Certain Services may require you to agree
              to additional terms specific to the use of such Services. You understand and agree that
              in order to use our Services and create an Account, you must provide us with a verifiable
              physical address that is not a P.O. Box or Commercial Mail Receiving Agency in order to
              be granted an Account.
            </p>
            <p>
              Each Trucker Path Account is unique. Additional users may be added to an Account subject
              to the fees agreed to by the parties. Each user must register with an individual, unique
              email address and password to access Trucker Path Services. Truckstop may limit the number
              of user names and passwords associated with your Account. Truckstop reserves the right to
              bump users off the system if more than one user attempts to login with the same email
              address and password at the same time.
            </p>
            <h4>5. RIGHTS GRANTED AND APPROPRIATE USE</h4>
            <p>
              Subject to your compliance with these Terms and Conditions, Trucker Path grants you
              a non-assignable, non-transferable, non-exclusive, revocable right to: (a) access and
              use the Services on your hardware solely in connection with your use of the Services;
              and (b) access and use any content, information or related materials that may be made
              available through the Services.
            </p>
            <p>
              You may not: (a) copy (except as set forth in this Section 5 below), modify, distribute,
              sell, license, sublicense, assign, transmit, publish or republish, display, perform, edit,
              create derivative works from, transfer, lease, sell or license any part of the Services
              to a third party; (b) reverse engineer, dissemble, decompile or work around any technical
              limitations of the Services; (c) copy or retrieve data or other content provided by us to
              you, either manually or by use of automatic devices, for the purpose of creating or
              compiling, directly or indirectly, a collection, database or directory or creating
              products competitive to the Services; or (d) use meta tags or other hidden text
              utilizing our name or trademarks or use framing techniques to enclose any portion
              of the Services. You may not make copies of any part of the Services except as
              reasonably necessary for your own internal business purposes.
            </p>
            <p>
              When you create an Account, you represent, warrant and covenant: (a) you are or
              represent a bona fide carrier, broker, shipper or are otherwise a business partner
              of Trucker Path; (b) you will comply with all applicable laws when using the Services
              (e.g., any prohibitions on mobile device use while driving), and you will use the Services
              for lawful purposes only (e.g., no transport of unlawful materials); (c) you will not
              permit non-registered and unauthorized users to use your Account or the Services without
              express written permission from Trucker Path; (d) your purpose in accessing and using the
              Services is not to directly or indirectly compete with or gain a competitive advantage in
              relation to us; (e) you will not use the Services and any postings made by you on the
              Services to advertise services for any third party entity or person; (f) you are not
              located in a country that is subject to a U.S. government embargo, or that has been
              designated by the U.S. government as a “terrorist supporting” country and you are not
              listed on any U.S. government list of prohibited or restricted parties.{' '}
              <span className={css.underLine}>Load Board serviceagreements allow only one user per agreement</span>.
              You further understand and agree that we
              reserve the right to restrict, in part or in full, access to the Services if we learn
              that you are an entity, or are affiliated with an entity, that provides a service
              competitive to our Services or if we believe you are attempting to create a competitive service.
            </p>
            <p>
              By violating any of the terms outlined in this Section 5, you risk having your
              Account terminated by us without warning and, in addition to being subject to any
              other legal remedies that may be available under these Terms and Conditions, or
              that may be available under applicable law, we may, in our sole discretion, elect
              to assess you a penalty in the amount of $1,000.00 for each unauthorized access or
              use of the Services by you or by a third party using your Account password or accessing
              your Account without our permission. To the extent we may have to sue you to enforce any
              of these Terms and Conditions, or other violations committed by you while accessing or
              using the Services, you expressly agree to bear the costs of that enforcement, including
              without limitation all related attorneys’ fees.
            </p>
            <h4>6. PROPRIETARY RIGHTS</h4>
            <p>
              The Services and rights in the Services are the property of Trucker Path or its
              licensors. The Services are protected by copyrights, trademarks, service marks,
              patents, trade secrets and other proprietary rights and laws. You may not remove,
              obscure or alter any copyright, trademark or other proprietary notices displayed
              on our Services. Neither these Terms and Conditions nor your use of the Services
              convey or grant to you any rights: (a) in or related to the Services except for
              the limited rights granted above; or (b) to use or reference in any manner the
              company names, logos, product and service names, trademarks or services marks of
              Trucker Path or its licensors.
            </p>
            <h4>7. SUBMISSION OF CONTENT</h4>
            <p>
              By submitting content in connection with your access and use of the Services, you:
            </p>
            <p>
              (a) Grant us and our licensees a worldwide, perpetual, transferrable,
              royalty-free right to use, reproduce, host, publicly display, publish, publicly perform, adapt,
              modify, distribute, promote and otherwise exploit in any manner the content in any form
              and distribution channels now known or subsequently devised for any purpose (including
              without limitation in connection with the Services and com’s business and on third party
              sites and services), without further notice to you, and without the requirement of payment
              to you or any other person or entity. These Terms and Conditions remain in effect even if you
              stop using the Services.
            </p>
            <p>
              (b) Represent, warrant and covenant that:
            </p>
            <ol className={css.romanListStyle}>
              <li>
                Your content is accurate, and that our posting and use of your content will not infringe
                or violate the rights of any third
              </li>
              <li>
                You will not list a phone number, email address, URL or other personally identifiable
                information in the “Special Information” field of posts or the “Company Notes” field of
                your Company Profile. If any personally identifiable information is listed or posted by
                you, you agree to hold Trucker Path harmless from exploitation of that information.
              </li>
              <li>
                You will not upload, post or transmit to or distribute or otherwise publish through our
                Services, any content that: (a) restricts or inhibits any other user from using or
                enjoying our Services; (b) is unlawful, threatening, abusive, libelous, defamatory,
                obscene, vulgar, offensive, pornographic, profane, sexually explicit or indecent;
                (c) constitutes or encourages conduct that would constitute a criminal offense,
                give rise to civil liability or otherwise violate law; (d) violates, plagiarizes or
                infringes the rights of third parties, including without limitation copyright, trademark,
                patent, rights of privacy or publicity or any other proprietary right;
                (e) constitutes defamatory or libelous statements; (f) contains a computer virus or
                other harmful component; (g) constitutes or contains false or misleading indications
                of origin or statements of fact; or (h) is inappropriate for the purpose of our
              </li>
            </ol>
            <p>
              We retain the right, but not the obligation, to review and remove any content submitted
              in connection with your access and use of the Services without notice to you.
            </p>
            <h4>8. PRIVACY POLICY</h4>
            <p>
              Our Privacy Policy is incorporated in these Terms and Conditions by reference.
              By accepting these Terms and Conditions, you expressly consent to the use and disclosure
              of your personally identifiable and other information as described in our Privacy Policy
              which can be accessed at (privacy site included here).
            </p>
            <h4>9. FEES</h4>
            <p>
              You agree to pay us for the Services in accordance with the fees, charges, taxes and billing
              terms in effect at the time a fee or charge is due and payable. According to the nature of
              some of our Services, fees may be required in advance of use. All fees must be paid in U.S.
              dollars unless specifically permitted otherwise by Trucker Path.
            </p>
            <h4>10. CANCELLATION</h4>
            <p>
              Trucker Path is a pay-in-advance service and you may request to cancel at any time.
              A request to cancel a Trucker Path account must be made at least 5 days prior to the
              next invoice date or the service will continue through the next billing period.
              Main and Billing users may make a cancellation request online through their account
              from the Billing page and clicking ‘Cancel Subscription’. Cancellation will only take
              effect when the entire cancellation process is completed. Simply canceling the credit/debit
              card associated with a Trucker Path account will not cancel the account.
            </p>
            <p>
              Cancellations will take effect on the last day of the billing period in which the
              cancellation is processed. No portion of a payment will be refunded or prorated at the
              time a cancellation request is made. Customers are encouraged to keep records of all
              communications regarding cancellation.
            </p>
            <p>
              Cancellation of an account does not resolve outstanding amounts owed or nullify previously
              agreed upon charges or fees, such as payments charged in installments or annual contract
              charges, portions of which may not yet have been invoiced at the time of your cancellation
              request. At the time of cancellation, any outstanding amounts owed to Trucker Path must be settled.
            </p>
            <p>
              Note: If you entered into a signed contract for your services, such as an annual contract,
              please review your contract for additional obligations. In the event the billing terms in
              your signed contract conflict with these Terms and Conditions, the terms of your signed
              contract will govern.
            </p>
            <h4>11. AUTOMATIC RECURRING BILLING</h4>
            <p>
              We will automatically renew and charge your credit card, withdraw from your account or
              issue an invoice to you (whichever form of payment you authorized at the time you set
              up your Account) (a) every month for monthly service agreements, (b) every quarter for
              quarterly service agreements, (c) each year on the subsequent anniversary for annual
              service agreements, or (d) monthly for annual service agreements.  In the event of an
              early termination of an annual service agreement that is paid monthly, Truckstop will
              charge your credit card for full payment for the remainder of the annual term. Renewal
              charges for each service agreement will be equal to the then-current service fee, unless
              we have mutually agreed otherwise. Fees for other services will be charged on an as-quoted
              basis.  Unpaid fees will result in suspension of the Services. Attempt for payment from your
              card on file may continue for up to 30 days after suspension for non-payment, unless you
              request to have your account cancelled (see section 10 on Cancellations). Once fees have been
              paid after suspension, you will be charged going forward at the then current rate for the Service(s).
            </p>
            <h4>12. REFUND POLICY</h4>
            <p>
              For our subscription-based Services, payment is made in advance for access over a certain
              period of time, regardless of actual usage. Subscriptions are non-cancellable for the pre-paid
              period of time and thus, we do not refund fees or pro-rate for partial usage.
            </p>
            <h4>13. ASSIGNMENT</h4>
            <p>
              We reserve the right to assign our rights and obligations under these Terms and Conditions
              to any subsidiary or affiliate, acquirer of some or all of Trucker Path’s equity, assets or
              business, or a successor by merger or other operation of law. You may not assign your Account
              or any of your rights or responsibilities under these Terms and Conditions without our express
              written consent. These Terms and Conditions will inure to the benefit of, be binding upon
              and be enforceable by our successors and assigns.
            </p>
            <h4>14. THIRD PARTY SERVICES AND CONTENT</h4>
            <p>
              The Services may be made available or accessed in connection with third party services and
              content that are not under our control and in no event will Trucker Path be responsible or
              liable for any products, services or content of such third-party providers. You acknowledge
              that different terms of use and privacy policies may apply to your use of such third-party
              services and content. Additionally, third parties, including but not limited to, Apple Inc.,
              Google Inc., Microsoft Corporation and BlackBerry Limited, will be a third-party beneficiary
              to this contract if you access the Services using mobile applications available for use on the
              third party’s mobile devices. These third-party beneficiaries are not parties to this contract,
              are not responsible for the provision or support of the Services in any manner and are not
              responsible for any investigation, defense, settlement and discharge of any third-party claim
              that the Services or your access and use of the Services infringe such third party’s intellectual
              property rights or any other third-party claim or claim made by you relating the Services or your
              access and use of the Services. Your access to the Services using these devices is subject to terms
              set forth in the applicable third-party beneficiary’s terms of use and you agree to comply
              with the applicable third-party beneficiary’s terms of use when using the Services.
            </p>
            <h4>15. NETWORK ACCESS, DEVICES AND ELECTRONIC COMMUNICATIONS</h4>
            <p>
              You are responsible for acquiring and updating any compatible hardware, data network access,
              Web browser and email account necessary to access and use the Services and any updates to the
              Services. You agree to receive information and other materials from us primarily through our
              websites, mobile applications and an email address you provide to us, and you agree to notify
              us of changes in your electronic contact information. Any materials or information provided
              to you by telephone, U.S. mail, facsimile or other means does not constitute a waiver of this
              contract. We do not guarantee that the Services will function on any particular hardware and
              the Services may be subject to malfunctions and delays inherent in the use of the Internet
              and electronic communications. If you access or use the Services from a wireless-enabled
              device, your mobile network’s rates and fees may apply.
            </p>
            <h4>16. NO CONFIDENTIAL OR CONTRACTUALLY IMPLIED RELATIONSHIP EXISTS WITH US</h4>
            <p>
              You acknowledge that by registering with us, submitting content to us for posting or any other
              purposes or using our Services, no confidential, fiduciary, contractually implied or other
              relationship is created between you and us other than the express contractual relationship set
              forth in these Terms and Conditions. Notwithstanding the foregoing, we will not disclose
              to third parties the source or identity of the ownership of any content licensed to us
              under this Agreement.
            </p>
            <h4>17. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY</h4>
            <p>
              Trucker Path does not function as a transportation broker or arrange for the movement of freight.
              All such arrangements are made by the users of the Services, and any terms and conditions of such
              freight movement, including without limitation any pricing or payment terms, are solely among the
              users of our Services. No agency, partnership, joint venture, employee–employer or
              franchisee–franchisor relationship is intended or created by your use of the Services
              or by these Terms and Conditions.
            </p>
            <p>
              You use the Services at your own risk. While we make reasonable efforts to post and supply
              accurate and timely information, we make no representations or warranties of the accuracy
              of content on the Services or content otherwise provided to you by us through an alternative
              means and assume no liability or responsibility for inaccuracies, errors or omissions in such
              content. Without limiting the foregoing in any way, we make no representations or warranties
              whatsoever: (a) regarding the reliability, timeliness, quality, suitability or availability
              of our Services; (b) that our Services will be uninterrupted or error- free; or (c) regarding
              the quality, qualifications, suitability, safety, accident history, vehicle history,
              criminal or civil liability history, creditworthiness or experience of any of the users of
              our Services. In addition, by using the Services, you acknowledge and agree that we do not,
              and have no duty to, conduct any investigations or evaluations relating to any of the
              foregoing. You fully and completely assume all risk of using the Services and any content,
              materials or information provided to you by us or any other user of the Services.
            </p>
            <p>
              NEITHER WE NOR ANY OTHER PARTY INVOLVED IN THE CREATION, DISTRIBUTION OR DISPLAY OF THE
              SERVICES OR ANY OTHER MATERIALS OR INFORMATION PROVIDED TO YOU BY US (COLLECTIVELY, “SUPPLIERS”)
              IS LIABLE FOR ANY LOST PROFITS OR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL OR
              CONSEQUENTIAL DAMAGES ARISING OUT OF OR THAT RESULT FROM: (A) YOUR USE, INABILITY TO ACCESS
              OR USE OR RELIANCE ON THE SERVICES OR ANY OTHER MATERIALS PROVIDED TO YOU BY US, EVEN IN THE
              EVENT OF OUR NEGLIGENCE; OR (B) ANY TRANSACTION OR RELATIONSHIP BETWEEN YOU AND ANY OTHER USER
              OF THE SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. TO THE
              EXTENT PERMITTED BY LAW, THE TOTAL LIABILITY OF TRUCKER PATH AND ITS SUPPLIERS FOR ANY CLAIMS
              UNDER THESE TERMS AND CONDITIONS IS LIMITED TO THE AMOUNT YOU PAID US TO USE THE SERVICES.
            </p>
            <p>
              WITHOUT LIMITING THE FOREGOING, AND TO THE FULL EXTENT PERMISSIBLE BY APPLICABLE LAW, ALL
              SERVICES AND ANY OTHER MATERIALS OR INFORMATION PROVIDED TO YOU BY US ARE DELIVERED AS IS
              AND AS AVAILABLE, WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT
              NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
              RELIABILITY, ABILITY TO MEET YOUR NEEDS OR NONINFRINGEMENT.
            </p>
            <p>
              WE DO NOT WARRANT THAT THE SERVICES OR ANY OF THEIR SERVERS ARE FREE OF VIRUSES OR OTHER
              HARMFUL COMPONENTS THAT MAY INFECT OR DAMAGE YOUR HARDWARE OR OTHER PROPERTY AS A RESULT OF
              YOUR ACCESSING, BROWSING OR USING THE SERVICES, DOWNLOADING INFORMATION OR PRINTING INFORMATION
              FROM THE SERVICES.
            </p>
            <h4>18. CLAIMS OF INFRINGEMENT</h4>
            <p>
              Just as we require users of the Services to respect our copyrights and other intellectual
              property rights, we respect the copyrights and other intellectual property rights of users
              of the Services and other third parties. It is Trucker Path’s policy to disable or terminate
              the Accounts of users who are repeat infringers. If you believe in good faith that your
              copyrighted work has been reproduced on the Services without authorization in a way that
              constitutes copyright infringement, you may notify us by mail to:
            </p>
            <p>
              <span className={cs(css.block, css.txtCenter)}>Trucker Path</span>
              <span className={cs(css.block, css.txtCenter)}>Re: Copyright Infringement</span>
              <span className={cs(css.block, css.txtCenter)}>2828 N Central Ave. 7th Floor</span>
              <span className={cs(css.block, css.txtCenter)}>Phoenix, AZ 85004</span>
            </p>
            <p>
              Please provide the following information:
            </p>
            <p>
              (a) The identity of the infringed work and of the allegedly infringing work;
              (b) identification of the content you believe to be infringing in a sufficiently precise
              manner to allow us to locate that content; (c) your name, address, daytime phone number
              and email address, if available; (d) a statement that you have a good-faith belief
              that the use of the copyrighted work is not authorized by the owner, his or her agent or the law;
              (e) a statement of the accuracy of the notice and, under penalty of perjury,
              that you are authorized to act on behalf of the owner; and (f) your electronic or physical signature.
            </p>
            <h4>19. USER’S INDEMNIFICATION</h4>
            <p>
              You agree to defend, indemnify and hold us and our employees, contractors, officers and
              managers harmless from all liabilities, claims and expenses, including without limitation
              attorneys’ fees, that arise out of or result from: (a) your use or misuse of the Services
              or any other materials or information provided by us to you (whether such material or
              information originates from us or from a third party, including without limitation other users
              of the Services); (b) your breach of these Terms and Conditions; (c) our use of any content
              submitted by you in connection with the Services; or (d) your violation of any law or the
              rights of a third party.
            </p>
            <h4>20. GOVERNING LAW</h4>
            <p>
              These Terms and Conditions shall be governed by and construed under the laws of the State
              of Arizona without regard to that state’s conflicts of law rules. By accessing and using
              the Services, you expressly agree that the exclusive jurisdiction for any claim or action
              arising out of or relating to these Terms and Conditions or your access or use of the Services
              is the state or federal courts located in Maricopa County, Arizona and that all claims or actions
              will be brought in those courts. You further agree and submit to the exercise of personal
              jurisdiction of such courts for the purpose of litigating any such claim or action.
            </p>
            <h4>21. SEVERABILITY AND INTEGRATION</h4>
            <p>
              These Terms and Conditions supersede any prior or contemporaneous communication
              (whether oral, written or electronic) between you and us regarding the Services.
              These Terms and Conditions also govern and are incorporated into any additional agreement
              or arrangement between you and us, including without limitation any agreement relating to
              the collection, compilation and supply of data from us. If any part of these Terms and
              Conditions is held void, invalid or unenforceable, that portion shall be construed to
              reflect the original intentions of the parties, and the remaining portions shall remain
              in full force and effect.
            </p>
            <h4>22. RIGHT TO AUDIT</h4>
            <p>
              Your expressly grant us the right to audit your facilities and records from time to time in
              order to verify your compliance with these Terms and Conditions. Any such audit shall only
              take place during your normal business hours and upon no less than five (5) days prior
              written notice from us.
            </p>
            <h4>23. FEEDBACK</h4>
            <p>
              Please submit feedback or suggestions about our Services to{' '}
              <a href='mailto:support@truckerpath.com'>support@truckerpath.com</a>{' '}
              We may use your feedback or suggestions without notice or obligation to you.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default TOS;



// WEBPACK FOOTER //
// ./src/components/pages/TOS/index.js